import PropTypes from 'prop-types';
import { addAppointmentFormPageData } from '../../../shared/components/AppointmentForm';
import AppointmentFormPage from './AppointmentFormPage';

const AppointmentFormPageWithData = addAppointmentFormPageData(AppointmentFormPage);

AppointmentFormPageWithData.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      providerId: PropTypes.string.isRequired,
      openingSlug: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default AppointmentFormPageWithData;
